require('../modules/es6.parse-int');
module.exports = require('../modules/_core').parseInt;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/es6/parse-int.js
// module id = 763
// module chunks = 2